import Vue from 'vue'

const state = {
  messages: [],
  unsentMessages: [],
  currentMessageText: '',
  newMessageModel: {
    Type: 'message',
    MessageID: '',
    MessageType: 0,
    To: '',
    From: '',
    Body: '',
    CreateDate: '',
    ConversationID: '',
    Status: 0,
    isGroup: false,
    ConversationType: 0
  },

  uploadersModel: {
    imageUploader: {
      isVisible: false,
      isUploadInterfaceVisible: false,
      bodyText: '',
      isMime: false,
      files: []
    },
    documentUploader: {
      isVisible: false,
      isUploadInterfaceVisible: false,
      bodyText: '',
      isMime: true,
      files: []
    }
  },

  previewModel: {
    imageGalleryView: {
      isVisible: false,
      files: []
    }
  },

  uploadFileModel: {
    processId: '',
    file: null,
    uploadUrl: '',
    uploadProgress: 0,
    uploadedSize: 0,
    fileSize: 0,
    uploadStatus: 0,
    resultURL: '',
    fileType: '',
    originalFileName: ''
  },
  imageBlobs: [],
  imageRequestList: [],

  ReplyMessage: null,
  isReplyMessageOpen: false,
  starredMessages: [],
  editingMessage: null
}

const mergeMessage = (target, source) => {
  Object.keys(source).forEach(key => {
    Vue.set(target, key, source[key])
  })
}

const deduplicateMessages = messages => {
  const uniqueMessages = []
  const messagesByID = new Map()

  for (const message of messages) {
    const existingMessage = message.MessageID
      ? messagesByID.get(message.MessageID)
      : undefined

    if (existingMessage) {
      mergeMessage(existingMessage, message)
    } else {
      uniqueMessages.push(message)
      if (message.MessageID) {
        messagesByID.set(message.MessageID, message)
      }
    }
  }

  return uniqueMessages
}

const getters = {
  activeConversationMessages: (state, getters, rootState) => {
    return getters.sortedMessagesOfConv(
      rootState.conversation.activeConversation
    )
  },

  sortedMessagesOfActiveConv: (state, getters, rootState) => {
    let d = getters.sortedMessagesOfConv(
      rootState.conversation.activeConversation
    )
    return d
  },

  pagedMessagesOfActiveConv: (state, getters, rootState) => {
    let d = getters.sortedMessagesOfConv(
      rootState.conversation.activeConversation
    )
    var page = rootState.conversation.conversationPage
    var messagePerPage = rootState.conversation.messagePerConversation
    var pagedMessages = d.slice(Math.max(0, d.length - messagePerPage * page), d.length)
    return pagedMessages
  },
  starredMessagesList: (state, getters, rootState) => {
    return state.starredMessages.sort(function (a, b) { return a.CreateDate > b.CreateDate ? -1 : 1 })
    // return state.starredMessages
  }
}

const mutations = {
  setMessages (state, data) {
    for (const iterator of data.rootState.conversation.clearedConversations) {
      let items
      if (iterator.isGroup) {
        items = data.filter(x => x.To === iterator.UniqueID && new Date(x.CreateDate).getTime() <= new Date(iterator.ClearDate).getTime())
      } else {
        items = data.filter(x => x.ConversationID === iterator.UniqueID && new Date(x.CreateDate).getTime() <= new Date(iterator.ClearDate).getTime())
      }
      if (items !== undefined) {
        for (const item of items) {
          let i = data.indexOf(item)
          if (i !== -1) {
            data.splice(i, 1)
          }
        }
      }
    }
    for (const iterator of state.starredMessages) {
      var item = data.find(x => x.MessageID === iterator.MessageID)
      if (item !== undefined) {
        item.isStarredMessage = true
      }
    }
    state.messages = deduplicateMessages(data)
  },

  appendMessages (state, data) {
    if (Array.isArray(data)) {
      data.forEach(function (el) {
        const existingMessage = el.MessageID
          ? state.messages.find(message => message.MessageID === el.MessageID)
          : undefined
        if (existingMessage) {
          mergeMessage(existingMessage, el)
        } else {
          state.messages.push(el)
        }
      })
    }
  },

  clearActiveNewMessage (state, data) {
    data.rootState.conversation.activeConversation.newMessage.Body = ''
    state.newMessageModel.Body = ''

    state.isReplyMessageOpen = false
    setTimeout(() => {
      data.rootState.conversation.activeConversation.newMessage.ReplyMessage = null
      state.ReplyMessage = null
    }, 300)
  },

  deleteMessage (state, data) {
    let messageToDelete = state.messages.find(m => m.MessageID === data.MessageID)
    messageToDelete.DeleteStatus = 12
    messageToDelete.Status = 11
  }
}

const actions = {
  setMessages (context, data) {
    data.rootState = context.rootState
    context.commit('setMessages', data)
  },

  appendMessages (context, data) {
    context.commit('appendMessages', data)
  },

  clearActiveNewMessage (context) {
    let data = {}
    data.rootState = context.rootState
    context.commit('clearActiveNewMessage', data)
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}
